import React, { useState } from 'react';
import classNames from 'classnames';
import { PAYWALL_ROW_ITEM_PROP_TYPES } from './constants';
import MainRowItem from '../main-row-item';
import PlanRowItem from '../plan-row-item';

const PaywallRowItem = ({
  title,
  tooltip = null,
  disabled = false,
  loading = false,
  availabilities,
  highlightedElementId = '',
  highlighted = false,
  onTooltipHover = Function.prototype,
}) => {
  const [hover, setHover] = useState(false);

  const onMouseEnter = () => setHover(true);
  const onMouseLeave = () => setHover(false);

  const classes = classNames('ws-ui-paywall-row-item', {
    'ws-ui-paywall-row-item--highlighted': highlighted,
  });
  const cellClasses = classNames('ws-ui-paywall-row-item__cell', {
    'ws-ui-paywall-row-item__cell--hovered': hover,
  });

  return (
    <div className={classes} onMouseLeave={onMouseLeave} onMouseEnter={onMouseEnter}>
      <div className={cellClasses}>
        <MainRowItem
          title={title}
          tooltip={tooltip}
          disabled={disabled}
          loading={loading}
          hover={hover}
          onTooltipHover={onTooltipHover}
        />
      </div>
      {availabilities.map(({ id, contentType, ...rest }) => (
        <div
          className={classNames(cellClasses, {
            'ws-ui-paywall-row-item__cell--highlighted': highlightedElementId === id,
          })}
          key={id}
        >
          <PlanRowItem
            loading={loading}
            hover={hover}
            contentType={disabled ? 'icon-minus' : contentType}
            {...rest}
          />
        </div>
      ))}
      {highlighted && (
        <React.Fragment>
          <span className="ws-ui-paywall-row-item__highlight-comet ws-ui-paywall-row-item__highlight-comet--first" />
          <span className="ws-ui-paywall-row-item__highlight-comet ws-ui-paywall-row-item__highlight-comet--second" />
        </React.Fragment>
      )}
    </div>
  );
};

PaywallRowItem.propTypes = PAYWALL_ROW_ITEM_PROP_TYPES;

export default PaywallRowItem;
